import moment from 'moment';
import { format } from 'date-fns';
import { es, ru, de, zhTW, fr, it, ko, pt, enUS, pl, ja } from 'date-fns/locale';
const languages = {
  chinese: zhTW,
  spanish: es,
  russian: ru,
  german: de,
  french: fr,
  italian: it,
  korean: ko,
  portuguese: pt,
  english: enUS,
  polish: pl,
  japanese: ja
};
const titles = {
  chinese: '尊敬的 LASTNAME FIRSTNAME 女士/先生,',
  spanish: 'Hola,',
  russian: 'Здраствуйте FIRSTNAME,',
  german: 'Sehr geehrte/r Herr/Frau LASTNAME,',
  french: 'Bonjour FIRSTNAME,',
  italian: 'Gentile Dott./Dott.ssa LASTNAME,',
  korean: 'FIRSTNAME LASTNAME 님께,',
  portuguese: 'Prezado(a),',
  english: 'Dear FIRSTNAME LASTNAME,',
  polish: 'Drogi Expercie,',
  japanese: 'LASTNAME 様'
};
export const validateAdditionalEmails = input => {
  const findFirstEmailInStringRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
  const emailRegex = /^[^\s,]+@[^\s,].+$/; //example of copy/paste from Outlook: "Stjepan Vrucina" <knb.stjepan.vrucina@atheneum.ai>, 

  const specialCharactersRemoved = input.replace(/[,<>"]/g, '').trim();
  let fullName = '';
  let email = '';
  const emailFromInput = specialCharactersRemoved.match(findFirstEmailInStringRegex); // if email was not found in string, input is invalid.

  if (!emailFromInput) return {
    fullName: input.trim(),
    email: input.trim(),
    invalid: true
  };
  email = emailFromInput[0].trim();
  fullName = specialCharactersRemoved.split(email).join('').trim(); // add extra name formatting if needed

  if (!fullName) fullName = email; //test extracted email against emailRegex defined in /legacy-platform/lib/emailRegex.js
  //needed because search with this regex doesn't work properly

  if (!emailRegex.test(email)) return {
    fullName,
    email,
    invalid: true
  };
  return {
    fullName,
    email
  };
};
export const updateTime = ({
  newStartTime,
  newEndTime,
  message,
  newDate,
  newDateNoTranslation,
  previouslySendLanguage,
  languageUpdated,
  schedule,
  expertDayOffset,
  timezone,
  timezoneTranslated,
  country,
  showExpertCountry
}) => {
  const email = message;

  if (email && email.includes(`<span class="dateTarget">`)) {
    const priviousDate = email.split(`<span class="dateTarget">`)[1].split('</span>')[0];
    const previousStart = email.split(`<span class="startTimeTarget">`)[1].split('</span>')[0];
    const previousEnd = email.split(`<span class="endTimeTarget">`)[1].split('</span>')[0];
    const updateDate = email.replace(priviousDate, !!previouslySendLanguage && !languageUpdated ? newDateNoTranslation : newDate);
    const updateTimeZone = updateDate.replace(updateDate.split(`<span class="timezoneTarget">`)[1].split('</span>')[0], `(UTC${moment(schedule.timeslots[0].time.start + expertDayOffset).tz(timezone).format('Z')}) ${!!timezoneTranslated ? timezoneTranslated : timezone}${showExpertCountry ? ' (' + country + ')' : ''}
      `);
    const updateEnd = updateTimeZone.replace(previousEnd, newEndTime);
    const updateStart = updateEnd.replace(previousStart, newStartTime);
    return updateStart;
  }

  if (email) {
    const updateDate = email.replace('DATE', `<span class="dateTarget">${newDate}</span>`);
    const updateEnd = updateDate.replace('ENDTIME', `<span class="endTimeTarget">${newEndTime}</span>`);
    const updateStart = updateEnd.replace('STARTTIME', `<span class="startTimeTarget">${newStartTime}</span>`);
    return updateStart;
  }

  return '';
};

const formatExpertInvite = (message, schedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, country, timezone, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry) => {
  const {
    internationalNumbers,
    tollFreeNumbers
  } = zoomNum[0];
  const internationalNums = internationalNumbers.split(',').map((num, i) => {
    const numNoSpaces = num.split(' ').join('');
    const formattedNum = numNoSpaces.split('(')[0];
    return `${country} toll number ${i += 1}: <a href="tel:${formattedNum},,${'MEETINGID'}#,,,,,,#,,,${availabilityStore.epl.id}#">1-Tap</a> ${num}`;
  }).join('<br/>');
  const tollFreeNums = tollFreeNumbers && tollFreeNumbers.split(',').map((num, i) => `${country} Toll Free number ${i += 1}: ${num}`).join('<br />');
  const scheduleStartTime = moment(schedule.timeslots[0].time.start + expertDayOffset);
  scheduleStartTime.tz(timezone);
  const scheduleEndTime = moment(schedule.timeslots[0].time.end + expertDayOffset);
  scheduleEndTime.tz(timezone);
  const addStartToDayOffset = new Date(schedule.timeslots[0].time.start + expertDayOffset);
  const newDate = format(addStartToDayOffset, 'EEEE, LLLL d, Y', {
    locale: languages[selectedLanguage]
  });
  const newDateNoTranslation = format(addStartToDayOffset, 'EEEE, LLLL d, Y', {
    locale: languages[!!previouslySendLanguage ? previouslySendLanguage.toLowerCase() : selectedLanguage]
  });
  const newStartTime = scheduleStartTime.format('HH:mm');
  const newEndTime = scheduleEndTime.format('HH:mm');

  if (message) {
    let result = updateTime({
      newStartTime,
      newEndTime,
      message,
      newDate,
      newDateNoTranslation,
      previouslySendLanguage,
      languageUpdated,
      schedule,
      expertDayOffset,
      timezone,
      timezoneTranslated,
      country,
      showExpertCountry
    }).replace('JAPANESETIME', `${format(new Date(schedule.timeslots[0].time.start + expertDayOffset), 'yyyy')}年${format(new Date(schedule.timeslots[0].time.start + expertDayOffset), 'M')}月${format(new Date(schedule.timeslots[0].time.start + expertDayOffset), 'd')}日  ${newStartTime} 時～ ${newEndTime}`).replace('CURRENCY', !!availabilityStore.epl.honorariumCurrency ? availabilityStore.epl.honorariumCurrency.name : '').replace('TIMEZONE', `<span class="timezoneTarget">(UTC${moment(schedule.timeslots[0].time.start + expertDayOffset).tz(timezone).format('Z')}) ${!!timezoneTranslated ? timezoneTranslated : timezone}${showExpertCountry ? ' (' + country + ')' : ''}</span>`).replace('____', availabilityStore.epl.honorarium).replace('HONORARIUM', availabilityStore.epl.honorarium).replace('ZOOMNUMBERS', tollFreeNums ? tollFreeNums : internationalNums).replace(message.split('</p>')[0].split('<p')[1], !!languageUpdated ? `>${titles[selectedLanguage]}` : message.split('</p>')[0].split('<p')[1]).replaceAll('FIRSTNAME', availabilityStore.epl.expert.firstName).replaceAll('LASTNAME', availabilityStore.epl.expert.lastName).replace('EPLID', availabilityStore.epl.id).replace('EMPLOYEESUBMITTED', `<p class="employeeSubmitted">${employeeSubmitted}</p>`).replace(' (LOCATION)', '').replace(`<p>You can check all the available dial in numbers here: https://atheneum-partners.zoom.us</p>`, `<p>You can check all the available dial in numbers <a href="https://atheneum-partners.zoom.us">here</a></p>`).replace(`<p>You can check all the available dial in numbers here: https://atheneum-partners.zoom.us/u/ab6dpgC1N3</p>`, `<p>You can check all the available dial in numbers <a href="https://atheneum-partners.zoom.us/u/ab6dpgC1N3">here</a></p>`).replace('https://atheneum-partners.zoom.us//', '<div id="expertJoinUrl">JOIN_URL</div>');

    if (availabilityStore.schedule && availabilityStore.schedule.zoomMeetingId) {
      result = result.replaceAll('MEETINGID', availabilityStore.schedule.zoomMeetingId);
    }

    if (!result.includes(`<span type="hidden" id=`)) {
      return result.concat(`<span type="hidden" id="${templateId}"></span>`);
    }

    return result.replace(result.split('<span type="hidden" id="')[1].split('"></span>'), templateId);
  }

  return '';
};

export default formatExpertInvite;